import {isMobile} from 'mobile-device-detect';

export const imageProcess = {
  getImgMinSize(img) {
    const ZOOM_LIMIT_PERCENT = 30;

    let minWidth = 0, minHeight = 0;

    if (img) {
      let W, H, k;

      if (window.innerWidth > window.innerHeight) {
        H = window.innerHeight - (isMobile ? 180 : 200);
        k = H / img.height;
        W = img.width * k;
      } else {
        W = window.innerWidth;
        k = W / img.width;
        H = img.height * k;
      }

      minWidth = W - W / 100 * ZOOM_LIMIT_PERCENT;
      minHeight = H - H / 100 * ZOOM_LIMIT_PERCENT;

      return {minWidth, minHeight};
    }
  },
};
